import { render, staticRenderFns } from "./MediaEditor.vue?vue&type=template&id=47f86844&"
import script from "./MediaEditor.vue?vue&type=script&lang=js&"
export * from "./MediaEditor.vue?vue&type=script&lang=js&"
import style0 from "./MediaEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports